/**
 * @file コンポーネント：ポップアップ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";

// スタイル
export const StyledPopup = styled.div`
    display: none;
    position: fixed;
    top: 112px;
    left: calc(100% - 516px);
    z-index: ${zIndex.popup};
    width: 500px;
    max-height: calc(100% - 128px);
    overflow: auto;
    border-radius: 4px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    resize: both;
    transition: box-shadow 1s;

    &.is-fullheight {
        height: 100%;
    }

    &.is-highlight {
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5), inset 0 0 0 4px #00b700;
    }

    &.is-open {
        display: block;
    }

    &[data-position="bottom"] {
        top: initial;
        bottom: 16px;
    }
`;

export const StyledPopupContainerButton = styled.a`
    display: block;
    min-width: 88px;
    padding: 6px 8px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 24px;
    text-align: center;

    &[data-button-type="cancel"] {
        color: #25292d;
    }

    &[data-button-type="caution"] {
        background-color: #c31a1e;
        color: #ffffff;
    }

    &[data-button-type="submit"] {
        background-color: #061c72;
        color: #ffffff;
    }
`;

export const StyledPopupContainerButtonlist = styled.ul`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    margin-top: 24px;
    padding: 0 24px;
`;

export const StyledPopupContainerButtonlistItem = styled.li`
    margin-right: 4px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledPopupContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;

    > *:last-child {
        padding-bottom: 24px;
    }
`;

export const StyledPopupContainerClose = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #000000;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
`;

export const StyledPopupContainerContent = styled.div`
    flex-grow: 1;
    height: 100%;
    padding: 0 24px;
    overflow-y: auto;
`;

export const StyledPopupContainerHeader = styled.h2`
    flex-shrink: 0;
    width: 100%;
    padding: 24px;
    overflow: hidden;
    color: #212121;
    font-weight: normal;
    font-size: 20px;
    line-height: 28px;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: move;
`;
